(function(){
  function cfg(){
    return window.apx && window.apx.settings && window.apx.settings.animations ? window.apx.settings.animations : {};
  }

  function enabled(){
    var c = cfg();
    return c.enabled !== false;
  }

  function number(key, fallback){
    var c = cfg();
    var value = parseInt(c[key], 10);
    return isNaN(value) ? fallback : value;
  }

  function sliderSpeed(fallback){
    return enabled() ? number('sliderSpeed', fallback || 520) : 1;
  }

  function autoplayDelay(fallback){
    return number('sliderAutoplayDelay', fallback || 5000);
  }

  function preventDuplicate(){
    var c = cfg();
    return c.sliderPreventDuplicateInit !== false;
  }

  function hasJquery(){
    return !!window.jQuery && !!window.jQuery.fn;
  }

  function hasSlick(){
    return hasJquery() && !!window.jQuery.fn.slick;
  }

  function eachFreshSlick(selector, callback){
    if (!hasSlick()) return;
    var $items = window.jQuery(selector);
    if (preventDuplicate()) $items = $items.not('.slick-initialized');
    $items.each(function(){ callback(window.jQuery(this)); });
  }

  function initSlick(selector, options){
    eachFreshSlick(selector, function($el){
      if (!$el.children().length) return;
      $el.slick(options);
    });
  }

  window.initslide = function(){
    initSlick('.amz-trustpilot-slider-home', {
      infinite: true,
      speed: sliderSpeed(600),
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      centerPadding: '200px',
      autoplay: true,
      autoplaySpeed: autoplayDelay(5000),
      pauseOnHover: true,
      waitForAnimate: false,
      arrows: true,
      prevArrow:"<button type='button' class='slick-prev amztp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
      nextArrow:"<button type='button' class='slick-next amztp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
      responsive: [
        {breakpoint: 1000, settings: {centerMode: true, centerPadding: '100px', arrows: false, slidesToShow: 2, slidesToScroll: 2}},
        {breakpoint: 575, settings: {centerMode: true, arrows: false, centerPadding: '50px', slidesToShow: 1, slidesToScroll: 1}}
      ]
    });
  };

  window.swiperinitialized = function(){
    if (typeof window.Swiper === 'undefined') return;
    document.querySelectorAll('.myvideoSwiper').forEach(function(el){
      if (preventDuplicate() && el.swiper) return;
      new Swiper(el, {
        slidesPerView: 5.3,
        spaceBetween: 4,
        freeMode: true,
        loop: false,
        speed: sliderSpeed(500),
        touchRatio: number('sliderTouchSensitivity', 75) / 75,
        resistanceRatio: 0.65,
        passiveListeners: true,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next') || '.swiper-button-next',
          prevEl: el.querySelector('.swiper-button-prev') || '.swiper-button-prev',
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
          lockClass: 'swiper-button-lock'
        }
      });
    });
  };

  window.showNextDate = function(){
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var date = tomorrow.getDate();
    function ordinal(n){
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }
    var target = document.getElementById('amznextDate');
    if (target) target.textContent = days[tomorrow.getDay()] + ' ' + date + ordinal(date);
  };

  window.randomInventoryNumber = function(min, max){
    var randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    document.querySelectorAll('.amzrandomInven').forEach(function(el){ el.textContent = randomNum; });
  };

  window.initializereviewsliderHome = function(){
    initSlick('.amz-reviews-slider-slider-home', {
      infinite: true,
      speed: sliderSpeed(600),
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      centerPadding: '200px',
      autoplay: true,
      autoplaySpeed: autoplayDelay(5000),
      pauseOnHover: true,
      waitForAnimate: false,
      arrows: true,
      prevArrow:"<button type='button' class='slick-prev amztp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
      nextArrow:"<button type='button' class='slick-next amztp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
      responsive: [
        {breakpoint: 1200, settings: {centerMode: true, centerPadding: '50px', arrows: false, slidesToShow: 2, slidesToScroll: 2}},
        {breakpoint: 767, settings: {centerMode: true, arrows: false, centerPadding: '50px', slidesToShow: 1, slidesToScroll: 1}}
      ]
    });
  };

  window.initVideosSlider = function(){
    initSlick('.amz-video-slider-block', {
      infinite: true,
      speed: sliderSpeed(400),
      autoplay: true,
      autoplaySpeed: autoplayDelay(5000),
      slidesToShow: 5,
      pauseOnHover: true,
      waitForAnimate: false,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {breakpoint: 991, settings: {slidesToShow: 4, slidesToScroll: 4}},
        {breakpoint: 600, settings: {slidesToShow: 3, slidesToScroll: 3}},
        {breakpoint: 480, settings: {slidesToShow: 2, slidesToScroll: 2}}
      ]
    });
  };

  window.initUpsellSlider = function(){
    if (typeof window.Swiper === 'undefined') return;
    document.querySelectorAll('.amzUpsellSlider').forEach(function(el){
      if (preventDuplicate() && el.swiper) return;
      new Swiper(el, {
        slidesPerView: 1,
        grid: {rows: 2, fill: 'row'},
        spaceBetween: 10,
        speed: sliderSpeed(500),
        touchRatio: number('sliderTouchSensitivity', 75) / 75,
        resistanceRatio: 0.65,
        passiveListeners: true,
        pagination: {
          el: el.querySelector('.swiper-pagination') || '.swiper-pagination',
          clickable: true
        }
      });
    });
  };

  function initAll(){
    window.initslide();
    window.initializereviewsliderHome();
    window.initVideosSlider();
    window.swiperinitialized();
    window.initUpsellSlider();
    window.showNextDate();
  }

  document.addEventListener('DOMContentLoaded', function(){
    initAll();
    window.setTimeout(initAll, 250);
  });

  document.addEventListener('shopify:section:load', function(){
    window.setTimeout(initAll, 60);
  });

  document.addEventListener('shopify:section:select', function(){
    window.setTimeout(initAll, 60);
  });
})();
